module.exports = __webpack_public_path__ + "static/img/indexBtn3.fb30586.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/indexBtn3.jpg
// module id = lnyZ
// module chunks = 1